import React from "react";

function DeleteIcon() {
  return (
    <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="4" y="4" width="36" height="36" rx="18" fill="#FCF0ED"/>
        <rect x="2" y="2" width="40" height="40" rx="20" stroke="#FCF0ED" stroke-opacity="0.5" stroke-width="4"/>
        <path d="M13 16H15M15 16H31M15 16V30C15 30.5304 15.2107 31.0391 15.5858 31.4142C15.9609 31.7893 16.4696 32 17 32H27C27.5304 32 28.0391 31.7893 28.4142 31.4142C28.7893 31.0391 29 30.5304 29 30V16H15ZM18 16V14C18 13.4696 18.2107 12.9609 18.5858 12.5858C18.9609 12.2107 19.4696 12 20 12H24C24.5304 12 25.0391 12.2107 25.4142 12.5858C25.7893 12.9609 26 13.4696 26 14V16M20 21V27M24 21V27" stroke="#A82C0C" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  );
}

export default DeleteIcon;



